import React from 'react';
import { useTranslation } from 'react-i18next';
import * as LucideIcons from 'lucide-react';

import LoadingSpinner from './LoadingSpinner';

const AppSkeleton = () => {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen bg-cover bg-fixed font-lora text-gray-800 p-4 sm:p-8 relative" style={{ backgroundImage: 'url("https://i.postimg.cc/vHhqVDns/Untitled.gif")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="fixed top-4 left-4 p-2 bg-gray-800/50 rounded-full flex items-center space-x-2 h-[48px] w-[172px]" style={{ zIndex: 'var(--z-index-toast)' }}></div>
            <div className="fixed top-4 right-[4.5rem] p-3 rounded-full bg-blue-500/50 h-[48px] w-[48px]"></div>
            <div className="menu-toggle-button opacity-50"><LucideIcons.Menu size={24} /></div>

            <header className="text-center mb-10 relative z-10 opacity-80">
                <div className="title-container">
                    <h1 className="app-title text-4xl sm:text-5xl font-extrabold mb-4 font-playfair" style={{ animation: 'none', opacity: 1 }}>{t('app.title')}</h1>
                </div>
                <p className="font-playfair text-lg sm:text-xl text-blue-200 italic drop-shadow-md">{t('app.subtitle')}</p>
            </header>

            <main className="max-w-4xl mx-auto pb-20 relative z-10">
                <LoadingSpinner message={t('appSkeleton.initializing')} />
            </main>

            <footer className="text-center mt-10 text-gray-700 text-sm relative z-10 opacity-50">
                <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
            </footer>
        </div>
    );
}

export default AppSkeleton;
